module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_m_piebald.6cae3398.png";